import { Button } from "@authentic/loyalty-pwa/components/Button";
import { link } from "@authentic/loyalty-pwa/util";
import { Box } from "@authentic/loyalty-pwa/util/Box";
import { FunctionalComponent, h } from "preact";
import { Link } from "preact-router";
import { DelYeahContainer } from "../../../containers/DelYeahContainer";
import { NextIcon } from "../../../icons/Next";
import { LayoutStyled } from "./profile-settings.style";


export const DelYeahProfileAndSettings: FunctionalComponent = () => {
  const htmlTitle: string = 'Del Yeah! Rewards Profiles & Settings';
  const htmlMetaDescription: string = 'Your Del Yeah! Rewards Dashboard of available rewards and offers.';
  const IDItemMenuSelected: string = '7';

  return (
    <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>
      <LayoutStyled>
        <p>Need to make updates to your Del Yeah Rewards profile? Tap Edit My Profile to update your personal information or change your communication preferences.</p>
        <ul class="settings-menu">
          <li>
            <Link href={link("/edit-profile")}>
              Edit my profile
              <NextIcon></NextIcon>
            </Link>
          </li>
          <li>
            <Link href={link("/change-password-profile")}>
              Change Password
              <NextIcon></NextIcon>
            </Link>
          </li>
        </ul>

        <Box mt={48}>
          <Link href={link('/sign-out')}>
            <Button ariaLabel="Sign out" fullWidth>
              SIGN OUT
            </Button>
          </Link>
        </Box>
      </LayoutStyled>
    </DelYeahContainer >
  )
}
